import { render, staticRenderFns } from "./CommentReports.vue?vue&type=template&id=14d124d4&scoped=true"
import script from "./CommentReports.vue?vue&type=script&lang=ts"
export * from "./CommentReports.vue?vue&type=script&lang=ts"
import style0 from "./CommentReports.vue?vue&type=style&index=0&id=14d124d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d124d4",
  null
  
)

export default component.exports